import {
    ChangeDetectionStrategy,
    Component,
    OnDestroy,
    OnInit,
} from '@angular/core';
import {
    ActivatedRoute,
    Router,
} from '@angular/router';
import { AppStateFacade } from '@app-state';
import { PageMetadataRegistry } from '@app/router';
import { QueueDefinitionService } from '@services';

import {
    Observable,
    Subject,
} from 'rxjs';
import {
    map,
    takeUntil,
    tap,
} from 'rxjs/operators';

@Component({
    templateUrl: './transactions.page.html',
    providers: [QueueDefinitionService],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TransactionsPageComponent implements OnInit, OnDestroy {
    public queueId$!: Observable<number>;

    private _destroyed$ = new Subject();

    constructor(
        private _queueDefinitionService: QueueDefinitionService,
        private _route: ActivatedRoute,
        private _router: Router,
        private _appState: AppStateFacade,
        private _pageRegistry: PageMetadataRegistry,
    ) { }

    ngOnInit() {
        this.queueId$ = this._route.paramMap
            .pipe(
                map((params) => Number(params.get('id'))),
                tap((id) =>
                    this._queueDefinitionService
                        .getQueueNameById(id)
                        .pipe(takeUntil(this._destroyed$))
                        .subscribe((title) => this._pageRegistry.setCustomTitle(title), this.redirectToQueues),
                ),
            );

        this._appState.user.folder.change$
            .pipe(
                takeUntil(this._destroyed$),
            )
            .subscribe(this.redirectToQueues);
    }

    ngOnDestroy() {
        this._destroyed$.next();
    }

    public redirectToQueues = () => {
        // if the session has expired, the user will be navigated off
        // the page before the error callback
        if (this._router) {
            this._router.navigate(['/queues']);
        }
    }
}
